import { Box, Typography } from "@mui/material";
import useTranslations from "containers/hooks/useLanguageHook";

function NoVisualComponent() {
  const { t } = useTranslations();
  return (
    <Box
      sx={{
        position: "center",
        transform: `translate(0px,${Math.max(0, window.innerHeight / 3)}px)`,
      }}
    >
      <Typography variant="h3" align="center">
        {t.DataPage.NoDataLeft}
      </Typography>
    </Box>
  );
}
export default NoVisualComponent;
